import { defineAction } from '~/prix'
import { communityObject } from '~/packages/geo/community/communityObject'
import { latitude, longitude } from '~/prix/types/presets/geo'
import { z } from 'zod'
import { pointOfInterestObject } from '../pointOfInterestObject'
import pointOfInterestCommunitySearchAction from './pointOfInterestCommunitySearch.action.json' with { type: 'json' }

const pointOfInterestCommunitySearchDefinition = defineAction({
  ...pointOfInterestCommunitySearchAction,
  input: z
    .object({
      communityId: z.string().uuid().nullish(),
      latitude: latitude().nullish(),
      longitude: longitude().nullish(),
      pointOfInterestName: z.string().nullish(),
    })
    .superRefine((input, context) => {
      const hasLatitude = input.latitude != null
      const hasLongitude = input.longitude != null

      if (hasLatitude !== hasLongitude) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Informe latitude e longitude juntas para filtrar por localização.',
          path: hasLatitude ? ['longitude'] : ['latitude'],
        })
      }
    }),
  output: z.object({
    items: z.array(
      z.object({
        community: communityObject,
        pointsOfInterest: z.array(pointOfInterestObject),
      }),
    ),
    count: z.number(),
  }),
})

export default pointOfInterestCommunitySearchDefinition
